export type RateDetail = {
  serviceType: string;
  serviceName: string;
  packagingType: string;
  commit?: { dateDetail?: { dayFormat?: string } };
  ratedShipmentDetails?: {
    rateType?: string;
    totalNetCharge?: number;
    currency?: string;
    totalBaseCharge?: number;
    totalSurcharges?: number;
    shipmentRateDetail?: { totalSurcharges?: number; currency?: string };
  }[];
};

const money = (n?: number, currency?: string) =>
  typeof n === "number" ? `${n.toFixed(2)} ${currency ?? ""}`.trim() : "—";

export function RatesTable({ rates }: { rates: RateDetail[] }) {
  if (rates.length === 0) {
    return (
      <p className="text-sm text-gray-500">No rates available for this route.</p>
    );
  }
  return (
    <div className="border rounded-lg overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-b">
          <tr>
            <th className="text-left px-3 py-2 font-medium text-gray-700">
              Service
            </th>
            <th className="text-left px-3 py-2 font-medium text-gray-700">
              Delivery
            </th>
            <th className="text-right px-3 py-2 font-medium text-gray-700">
              Price
            </th>
          </tr>
        </thead>
        <tbody>
          {rates.map((rate) => {
            // FedEx returns one detail per requested rate type (ACCOUNT =
            // negotiated price the merchant pays, LIST = published price). Show
            // the negotiated net as the price, with the published net
            // struck-through as reference when it is higher.
            const details = rate.ratedShipmentDetails ?? [];
            const account =
              details.find((d) => d.rateType?.includes("ACCOUNT")) ??
              details[0];
            const list = details.find((d) => d.rateType?.includes("LIST"));
            const net = account?.totalNetCharge;
            const listNet = list?.totalNetCharge;
            const showList =
              typeof net === "number" &&
              typeof listNet === "number" &&
              listNet > net;
            return (
              <tr key={rate.serviceType} className="border-b last:border-0">
                <td className="px-3 py-2">
                  <div className="font-medium">
                    {rate.serviceName || rate.serviceType}
                  </div>
                  <div className="text-xs text-gray-400">
                    {rate.packagingType}
                  </div>
                </td>
                <td className="px-3 py-2 text-gray-600">
                  {rate.commit?.dateDetail?.dayFormat ?? "—"}
                </td>
                <td className="px-3 py-2 text-right">
                  <span className="font-semibold">
                    {money(net, account?.currency)}
                  </span>
                  {showList && (
                    <span className="ml-2 text-xs text-gray-400 line-through">
                      {money(listNet, list?.currency ?? account?.currency)}
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
